import { isEmpty } from 'lodash'
import moment from 'moment'
import React, { useCallback, useMemo } from 'react'

import { parseTime } from './helpers'
import TimePicker, { TTimePicker } from './index'

const TimePickerIso = (props: TTimePicker): React.ReactElement => {
  const {
    enableSeconds,
    value: externalValue,
    onChange: externalOnChange,
    ...rest
  } = props

  const value = useMemo(
    () => moment(externalValue).format('HH:mm'),
    [externalValue],
  )

  const onChange = useCallback(
    (v) => {
      const { hour, minute, second = 0 } = parseTime(v)

      const newValue = moment(
        isEmpty(externalValue) ? undefined : externalValue,
      )
        .set('hour', hour as number)
        .set('minute', minute as number)
        .set('second', second as number)
        .toISOString()

      if (externalOnChange) {
        externalOnChange(newValue)
      }
    },
    [externalOnChange, externalValue],
  )

  return (
    <TimePicker
      {...rest}
      value={value}
      onChange={onChange}
      enableSeconds={enableSeconds}
    />
  )
}

export default TimePickerIso
